import { Col, Row, Stack } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import "./report.css";
import axios from "axios";
import moment from "moment";

function SustainabilityReport() {
  const [tags, setTags] = useState([]);
  const [activeTag, setActiveTag] = useState("");
  const [sustainabilityReportList, setSustainabilityReportList] = useState([]);

  const fetchSustainabilityReportFromCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/sustainability-reports?sort=date:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      let uniqueTags = [...new Set(response.data.data.map((item) => item.tag))];
      setTags(uniqueTags);
      setActiveTag(uniqueTags[0]);
      setSustainabilityReportList(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchSustainabilityReportFromCMS();
  }, []);
  return (
    <>
      <div className="container page">
        <h1 className="page-title">Sustainability Reports</h1>
        {/* todo: button active color */}
        <Stack direction="horizontal" gap={3}>
          {tags.map((item, index) => {
            return (
              <div
                className={activeTag === item ? "btn-tag active" : "btn-tag"}
                onClick={() => setActiveTag(item)}
              >
                {item}
              </div>
            );
          })}
        </Stack>

        <div className="report-section">
          <Row>
            {sustainabilityReportList
              .filter((x) => x.tag === activeTag)
              .map((item, index) => (
                <Col md={6} lg={4}>
                  <div className="report-card d-flex flex-column justify-content-between content">
                    <div>
                      <h1>
                        {item.title.length < 100
                          ? item.title
                          : item.title.substring(0, 100) + "..."}
                      </h1>
                    </div>
                    <div>
                      <p>
                        {item.description.length < 130
                          ? parse(item.description)
                          : parse(item.description.substring(0, 130)) + "..."}
                      </p>
                      <div className="d-flex justify-content-between align-items-baseline report-link">
                        <Link to={item.pdfLink} target="_blank">
                          View Report
                        </Link>
                        <p>{moment(item.date).format("DD MMM YYYY")}</p>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
          </Row>
        </div>
      </div>
    </>
  );
}

export default SustainabilityReport;
